import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { RANK_BY } from './constant'
import { selectRankBy, selectTopCompany, selectYear } from './store/slice'
import { getTopPlayersTable } from './store/thunk'
import { TopPlayerTableContent } from './TopPlayerTableContent'

const TopPlayerTable = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const topCompany = useSelector(selectTopCompany)
  const year = useSelector(selectYear)
  const rankBy = useSelector(selectRankBy)
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getTopPlayersTable({
        OrganizationId: params.organizationId,
        Top: topCompany.value,
        Year: year.value,
        SortByAssets: rankBy.value === RANK_BY.totalAssets.value,
        SortByRevenue: rankBy.value === RANK_BY.netRevenue.value,
      }),
    )
  }, [locale, params.organizationId, topCompany, year, rankBy])

  return <TopPlayerTableContent />
}

export default TopPlayerTable
